import { fetchUserBenefits, marketPlaceLogon } from "../../services/wapi";
import { useEffect, useState } from "react";
import { AddFamilyMember } from "./addBenefDialog";
import { CircularProgress, Backdrop } from "@mui/material";
import { Image } from "react-bootstrap";
import errorImage from "../../assets/NotFound.png";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import DependantHeaderSample from "../common/dependantHeaderSample";
import { labsDetails } from "../../constants/constant";

export const UserBenefits = () => {
	const [isLoading, setLoading] = useState(false);
	const [showError, setError] = useState(false);

	const [user, setUser] = useState({
		shortToken: localStorage.getItem("user_short_token"),
	});

	const [walletConfiguration, setWalletConfiguration] = useState({});

	const [benefs, setBenefs] = useState([]);

	const [benefPopup, setBenefPopupVisibility] = useState(false);
	const [allowedRelations, setAllowedRelations] = useState([]);
	const [isFamilyFlowEnabled, setIsFamilyFlowEnabled] = useState(false);
	const [isBenefAdditionAllowed, setIsBenefAdditionAllowed] = useState(false);
	const [compulsoryFields, setCompulsoryFields] = useState({});

	const history = useHistory();

	useEffect(async () => {
		await updateBeneficiaries();
	}, []);

	const updateBeneficiaries = async () => {
		try {
			setLoading(true);

			const orderDetails = JSON.parse(localStorage.getItem("parentOrderDetails"));
			const benefits = await fetchUserBenefits(
				{ loginDetails: labsDetails.userLoginDetails, userId:  orderDetails?.userId},
				user.shortToken,
			);
			setAllowedRelations(benefits.allowedRelations);
			setIsBenefAdditionAllowed(benefits.isBenefAdditionAllowed);
			setIsFamilyFlowEnabled(benefits.isFamilyFlowEnabled);
			setCompulsoryFields(benefits.compulsoryField);

			setWalletConfiguration({
				totalWalletBalance: benefits.totalWalletBalance,
				walletConfig: benefits.walletConfig,
			});
			
			setUser({
				...user,
				isRXRequired: benefits.isRXRequired,
				isRXVerificationRequired: benefits.isRXVerificationRequired,
				isUpsellRxVerificationEnabled: benefits.isUpsellRxVerificationEnabled
			});

			setBenefs(
				checkForWalletEligibility(
					[10386, 10389],
					benefits.beneficiaries,
					benefits.walletConfig,
				),
			);
		} catch (ex) {
			setError(true);
		} finally {
			setLoading(false);
		}
	};

	const checkForWalletEligibility = (
		contractIds,
		beneficiaries,
		walletConfig,
	) => {
		beneficiaries.forEach((benef) => {
			if (!benef.walletDetails?.length) return;

			benef.walletDetails = benef.walletDetails.filter((x) => {
				return contractIds.some((y) =>
					walletConfig[x.wallet].contractIds.includes(y),
				);
			});
		});

		return beneficiaries;
	};

	const handleAddTestsClick = (benef) => {
		benef.isRXRequired = user.isRXRequired;

		benef.isRXVerificationRequired = user.isRXVerificationRequired;
		benef.isUpsellRxVerificationEnabled = user.isUpsellRxVerificationEnabled;

		localStorage.setItem("selectedBenef", JSON.stringify(benef));

		history.push("/packageSelection");
	};

	return (
		<>
			<div className="order-details-dashboard p-b-10">
				<div>
					<div className="header-sample">
						<i
							className="fa fa-chevron-circle-left"
							onClick={() => history.push("/dependantOrders")}
						></i>
					</div>
					<DependantHeaderSample
						titleCall={true}
						noCall={true}
						title="Create Order"
					></DependantHeaderSample>
				</div>
				<Backdrop open={isLoading} sx={{ zIndex: 99999 }}>
					<CircularProgress />
				</Backdrop>

				{!showError && (
					<>
						<div className="p-3 m-b-50">
							{benefs.map((benef, idx) => (
								<div key={idx} className="my-4">
									<div className="rounded-lg border-dark border p-2 my-2">
										<div className="display-flex justify-content-between">
											<div> 
												<strong> Relation: </strong>
												<span className="text-primary">{benef.relationName}</span>
											</div>
											{benef.isAHCEligible && (
											<div className="text-danger">
												<b>AHC Pending</b>
											</div>
										)}
										</div>
										<div>
											<strong> Name: </strong>
											<span>{`${benef.name}(${benef.gender}, ${benef.age})`}</span>
										</div>
										<div>
											<strong> Is wallet available: </strong>
											<span>{benef.walletDetails?.length ? "Yes" : "No"}</span>
										</div>
										{benef.walletDetails?.length && (
											<div className="my-3">
												<table className="table table-sm">
													<thead>
														<tr>
															<th scope="col">Wallet</th>
															<th scope="col">Balance</th>
															<th scope="col">Shared</th>
														</tr>
													</thead>
													<tbody>
														{benef.walletDetails.map((x, idx) => {
															return (
																<tr key={idx}>
																	<td>
																		{
																			walletConfiguration.walletConfig[x.wallet]
																				.alias
																		}
																	</td>
																	<td>{x.balance}</td>
																	<td>{x.floater ? "Yes" : "No"}</td>
																</tr>
															);
														})}
													</tbody>
												</table>
											</div>
										)}
										<div className="my-3">
											<strong>Is Rx required for wallet orders: </strong>
											<span>
												{benef.walletDetails?.length && user.isRXRequired
													? "Yes"
													: "No"}
											</span>
										</div>
										<div className="text-right">
											<button
												type="button"
												className="btn btn-primary"
												onClick={() => handleAddTestsClick(benef)}
											>
												Add HC/tests
											</button>
										</div>
									</div>
								</div>
							))}
						</div>

						<div className="fixed-footer-container">
							<button
								type="button"
								className="btn btn-primary"
								onClick={() => setBenefPopupVisibility(true)}
								disabled={isFamilyFlowEnabled && !isBenefAdditionAllowed}
							>
								Add Family Member
							</button>
						</div>

						<AddFamilyMember
							visible={benefPopup}
							setVisibility={setBenefPopupVisibility}
							onSuccess={updateBeneficiaries}
							data={{
								shortToken: user.shortToken,
								availableRelations: allowedRelations,
								isFamilyFlowEnabled: isFamilyFlowEnabled,
								isBenefAdditionAllowed: isBenefAdditionAllowed,
								compulsoryFields: compulsoryFields
							}}
						/>
					</>
				)}

				{showError && (
					<div className="text-center">
						<Image src={errorImage} height="300" />
						<p className="m-t-20 text-danger bold">No benefits found</p>
					</div>
				)}
			</div>
		</>
	);
};
